import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { getUserSupplementSettings } from '@api/supplements';
import { IUserSupplementImageSettings } from '@interfaces/supplements';

export const handleGetUserSupplementSettings = createAsyncThunk<
  AxiosResponse<IUserSupplementImageSettings>,
  void
>('getUserSupplementSettings', getUserSupplementSettings);
